import { useContext } from "react";
import { StaticDataContext} from "../context"

const useStaticData = () => {
    return useContext(StaticDataContext)
}

export default useStaticData
